import React from "react";
import ModalWrapper from "components/common/ModalWrapper";
import ClickToCopyWrapper from "components/common/ClickToCopyWrapper";

const codeStyle =
  "font-mono text-sm font-semibold text-gray-600 rounded p-1 bg-gray-200";

class EquationHintModal extends React.Component {
  render() {
    return (
      <ModalWrapper
        isOpen={true}
        showCloseFooter={true}
        customOverlayStyle={{ zIndex: 100 }}
        handleClose={this.props.handleClose}
        title="Using Tags for Advanced Search"
      >
        <div className="mt-2 font-semibold text-gray-800">
          Comparison Operators
        </div>
        <ul className="list-disc pl-8">
          <li>
            <span className={codeStyle}>{`>`}</span> (greater than),{" "}
            <span className={codeStyle}>{`>=`}</span> (greater than or equal to)
          </li>
          <li>
            <span className={codeStyle}>{`<`}</span> (less than),{" "}
            <span className={codeStyle}>{`<=`}</span> (less than or equal to)
          </li>
          <li>
            <span className={codeStyle}>{`==`}</span> (equals)
          </li>
          <li>
            Example:{" "}
            <div className="flex items-center">
              <span className={codeStyle}>{`DROP_OFF_RATE_VIDEO >= 50`}</span>
              <div className="text-blue-600">
                <ClickToCopyWrapper
                  copyText={`DROP_OFF_RATE_VIDEO >= 50`}
                ></ClickToCopyWrapper>
              </div>
            </div>
          </li>
        </ul>

        <div className="mt-2 font-semibold text-gray-800">
          Logical Operators
        </div>
        <ul className="list-disc pl-8">
          <li>
            Use <span className={codeStyle}>&&</span> or{" "}
            <span className={codeStyle}>AND</span> for "and" conditions.
          </li>
          <li>
            Use <span className={codeStyle}>||</span> or{" "}
            <span className={codeStyle}>OR</span> for "or" conditions.
          </li>
          <li>
            Example:{" "}
            <div className="flex items-center">
              <span
                className={codeStyle}
              >{`IMP_PCT:GOOGLE > 10 || IMP_PCT:GUARANTEED > 10`}</span>
              <div className="text-blue-600">
                <ClickToCopyWrapper
                  copyText={`IMP_PCT:GOOGLE > 10 || IMP_PCT:GUARANTEED > 10`}
                ></ClickToCopyWrapper>
              </div>
            </div>
            <div className="flex items-center">
              <span
                className={codeStyle}
              >{`DROP_OFF_RATE_VIDEO >= 50 && VIDEO_CS_PCT > 10`}</span>
              <div className="text-blue-600">
                <ClickToCopyWrapper
                  copyText={`DROP_OFF_RATE_VIDEO >= 50 && VIDEO_CS_PCT > 10`}
                ></ClickToCopyWrapper>
              </div>
            </div>
          </li>
        </ul>

        <div className="mt-2 font-semibold text-gray-800">
          Checking Tag Existence
        </div>
        <ul className="list-disc pl-8">
          <li>
            Use <span className={codeStyle}>true</span> or{" "}
            <span className={codeStyle}>false</span> to check if a tag exists.
          </li>
          <li>
            Example:
            <div className="flex items-center">
              <span className={codeStyle}>REFRESH == true</span>
              <div className="text-blue-600">
                <ClickToCopyWrapper
                  copyText={`REFRESH == true`}
                ></ClickToCopyWrapper>
              </div>
              (Filter units with tag:REFRESH)
            </div>
            <div className="flex items-center">
              <span className={codeStyle}>REQ_PCT:HBPB == false</span>
              <div className="text-blue-600">
                <ClickToCopyWrapper
                  copyText={`REQ_PCT:HBPB == false`}
                ></ClickToCopyWrapper>
              </div>
              (Excludes units with tag:REQ_PCT:HBPB)
            </div>
            <div className="flex items-center">
              <span className={codeStyle}>LOW_ECPM == false</span>
              <div className="text-blue-600">
                <ClickToCopyWrapper
                  copyText={`LOW_ECPM == false`}
                ></ClickToCopyWrapper>
              </div>
              (Excludes units with tag:LOW_ECPM)
            </div>
          </li>
        </ul>

        <div className="mt-2 font-semibold text-gray-800">
          Grouping Conditions
        </div>
        <ul className="list-disc pl-8">
          <li>
            Use <span className={codeStyle}>()</span> to group conditions.
          </li>
          <li>
            Example:{" "}
            <div className="flex items-center">
              <span
                className={codeStyle}
              >{`(DROP_OFF_RATE_VIDEO > 10 || DROP_OFF_RATE_DISPLAY < 5) && REQ_PCT:UPA == 20`}</span>
              <div className="text-blue-600">
                <ClickToCopyWrapper
                  copyText={`(DROP_OFF_RATE_VIDEO > 10 || DROP_OFF_RATE_DISPLAY < 5) && REQ_PCT:UPA == 20`}
                ></ClickToCopyWrapper>
              </div>
            </div>
          </li>
        </ul>

        <div className="mt-2 font-semibold text-gray-800">
          Advanced Examples
        </div>
        <ul className="mb-2 list-disc pl-8">
          <li>
            <div className="flex items-center">
              <span
                className={codeStyle}
              >{`(REFRESH == true OR VIDEO_CREATIVE == true) && DROP_OFF_RATE_VIDEO > 5`}</span>
              <div className="text-blue-600">
                <ClickToCopyWrapper
                  copyText={`(REFRESH == true OR VIDEO_CREATIVE == true) && DROP_OFF_RATE_VIDEO > 5`}
                ></ClickToCopyWrapper>
              </div>
            </div>
          </li>
          <li>
            <div className="flex items-center">
              <span
                className={codeStyle}
              >{`IMP_PCT:GOOGLE > 50 && IMP_PCT:GOOGLE < 60 && VIDEO_CREATIVE == true`}</span>
              <div className="text-blue-600">
                <ClickToCopyWrapper
                  copyText={`IMP_PCT:GOOGLE > 50 && IMP_PCT:GOOGLE < 60 && VIDEO_CREATIVE == true`}
                ></ClickToCopyWrapper>
              </div>
            </div>
          </li>
        </ul>
      </ModalWrapper>
    );
  }
}

export default EquationHintModal;
